export const ASSET_PATH = window.prhReactWishlistSidePanel.pluginLocation;



// WEBPACK FOOTER //
// ./src/utilities.js